import React, { useState } from 'react';
import { Navigation } from './Navigation';
import { Menu, X } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Navigation Sidebar - Desktop */}
      <div className="hidden lg:block w-72 flex-shrink-0 shadow-2xl">
        <Navigation />
      </div>

      {/* Mobile Navigation Overlay */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setMobileMenuOpen(false)} />
      )}

      {/* Mobile Navigation Drawer */}
      <div className={`fixed inset-y-0 left-0 w-72 z-50 transform transition-transform duration-300 lg:hidden ${
        mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        <div className="relative h-full">
          <button
            onClick={() => setMobileMenuOpen(false)}
            className="absolute top-4 right-4 p-2 text-white hover:text-stratos-gold z-10"
          >
            <X className="w-6 h-6" />
          </button>
          <Navigation />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden w-full">
        {/* Header Premium */}
        <header className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border-b border-stratos-gold/30 px-4 sm:px-6 lg:px-8 py-4 lg:py-6 shadow-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              {/* Mobile Menu Button */}
              <button
                onClick={() => setMobileMenuOpen(true)}
                className="lg:hidden p-2 text-white hover:text-stratos-gold"
              >
                <Menu className="w-6 h-6" />
              </button>
              
              <div>
                <h2 className="text-base sm:text-lg lg:text-xl font-bold text-white flex items-center gap-2 lg:gap-3">
                  <span className="text-stratos-gold">●</span>
                  <span className="hidden sm:inline">Plateforme d'Analyse SEO/GEO</span>
                  <span className="sm:hidden">STRATOS</span>
                </h2>
                <p className="text-xs sm:text-sm text-gray-300 mt-1 hidden sm:block">
                  Analyse complète et recommandations stratégiques
                </p>
              </div>
            </div>
            
            <div className="flex items-center gap-3 lg:gap-6">
              <div className="text-right hidden md:block">
                <p className="text-xs text-gray-500">Dernière mise à jour</p>
                <p className="text-sm font-semibold" style={{ color: '#E9BC66' }}>
                  {new Date().toLocaleDateString('fr-FR', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })}
                </p>
              </div>
              <div className="h-8 lg:h-12 w-px hidden md:block" style={{ backgroundColor: 'rgba(233, 188, 102, 0.3)' }} />
              <div className="flex items-center gap-2">
                <div 
                  className="w-8 h-8 lg:w-10 lg:h-10 rounded-full flex items-center justify-center text-gray-900 font-bold text-xs lg:text-sm"
                  style={{
                    background: 'linear-gradient(to right, #E9BC66, #D4A84F)'
                  }}
                >
                  AC
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="max-w-[1600px] mx-auto">
            {children}
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 px-4 sm:px-6 lg:px-8 py-3 lg:py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between text-xs sm:text-sm text-gray-600 gap-2 sm:gap-0">
            <div className="flex items-center gap-2">
              <span className="text-stratos-gold font-semibold">STRATOS Hospitality</span>
              <span className="hidden sm:inline">×</span>
              <span className="hidden sm:inline">Consulting Premium F&B</span>
            </div>
            <div className="flex items-center gap-3 sm:gap-6">
              <span className="hidden sm:inline">contact@stratos360.fr</span>
              <span className="text-stratos-gold hidden sm:inline">●</span>
              <span>+33 6 64 27 60 32</span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};